import {
  getBorderStyles,
  getColorStyles,
  getCommonStyles,
  getCSSStyles,
  getFlexStyles,
  getLayoutStyles,
  getOpacityStyles,
  getShadowStyles,
  getTypographyStyles,
  getZIndexStyles,
} from './styledUtils';

export const getAllStyledProps = [
  getCommonStyles,
  getLayoutStyles,
  getBorderStyles,
  getColorStyles,
  getOpacityStyles,
  getShadowStyles,
  getTypographyStyles,
  getFlexStyles,
  getZIndexStyles,
  getCSSStyles,
];
